


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Slidar } from '../AdminDashbord/Slidar';
import './AdminTestimonial.css';

const AdminTestimonial = () => {
  const [achievement, setAchievement] = useState({ title: '', desc: '' });
  const [achievementImage, setAchievementImage] = useState(null);
  const [achievements, setAchievements] = useState([]);

  const [testimonial, setTestimonial] = useState({ name: '', desc: '', company: '', month: '', day: '' });
  const [testimonialImage, setTestimonialImage] = useState(null);
  const [testimonials, setTestimonials] = useState([]);

  const [editAchId, setEditAchId] = useState(null);
  const [editTestId, setEditTestId] = useState(null);
  const [showAchForm, setShowAchForm] = useState(false);
  const [showTestForm, setShowTestForm] = useState(false);

  const BASE_URL = '';

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const ach = await axios.get(`${BASE_URL}/api/achievements`);
      setAchievements(ach.data);
      const test = await axios.get(`${BASE_URL}/api/testimonials`);
      setTestimonials(test.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleAchievementSubmit = async () => {
    const formData = new FormData();
    formData.append('img', achievementImage);
    formData.append('title', achievement.title);
    formData.append('desc', achievement.desc);

    try {
      if (editAchId) {
        await axios.put(`${BASE_URL}/api/achievements/${editAchId}`, formData);
        alert("Achievement updated");
        setEditAchId(null);
      } else {
        await axios.post(`${BASE_URL}/api/achievements`, formData);
        alert("Achievement added");
      }
      setAchievement({ title: '', desc: '' });
      setAchievementImage(null);
      setShowAchForm(false);
      fetchData();
    } catch (err) {
      alert("Failed to save achievement");
    }
  };

  const handleTestimonialSubmit = async () => {
    const formData = new FormData();
    formData.append('img', testimonialImage);
    formData.append('name', testimonial.name);
    formData.append('desc', testimonial.desc);
    formData.append('company', testimonial.company);
    formData.append('month', testimonial.month);
    formData.append('day', testimonial.day);

    try {
      if (editTestId) {
        await axios.put(`${BASE_URL}/api/testimonials/${editTestId}`, formData);
        alert("Testimonial updated");
        setEditTestId(null);
      } else {
        await axios.post(`${BASE_URL}/api/testimonials`, formData);
        alert("Testimonial added");
      }
      setTestimonial({ name: '', desc: '', company: '', month: '', day: '' });
      setTestimonialImage(null);
      setShowTestForm(false);
      fetchData();
    } catch (err) {
      alert("Failed to save testimonial");
    }
  };

  const handleDelete = async (id, type) => {
    if (window.confirm(`Are you sure you want to delete this ${type}?`)) {
      try {
        const endpoint = type === 'achievement' ? 'achievements' : 'testimonials';
        await axios.delete(`${BASE_URL}/api/${endpoint}/${id}`);
        fetchData();
      } catch (error) {
        alert(`Failed to delete ${type}`);
      }
    }
  };

  const handleEdit = (item, type) => {
    if (type === 'achievement') {
      setAchievement({ title: item.title, desc: item.desc });
      setEditAchId(item._id);
      setShowAchForm(true);
    } else {
      setTestimonial({ 
        name: item.name, 
        desc: item.desc, 
        company: item.company, 
        month: item.month, 
        day: item.day 
      });
      setEditTestId(item._id);
      setShowTestForm(true);
    }
  };

  return (
    <div className="admin-testimonial-container">
      {/* Sidebar */}
      <div >
        <Slidar />
      </div>

      {/* Main content */}
      <div className="admin-testimonial-content">
   

        <hr style={{ margin: '30px 0' }} />

        {/* Testimonial Section */}
        <div style={{ textAlign: 'right', margin: '30px 0 10px' }}>
          <button
            className="toggle-test-btn"
            onClick={() => {
              setShowTestForm(!showTestForm);
              setEditTestId(null);
              setTestimonial({ name: '', desc: '', company: '', month: '', day: '' });
              setTestimonialImage(null);
            }}
          >
            {showTestForm ? '❌ Close Form' : '➕ Add Employee Testimonial'}
          </button>
        </div>

     {showTestForm && (
  <div style={{ marginBottom: '20px' }}>
    <h2>{editTestId ? 'Edit' : 'Add'} Testimonial</h2>
    
    <div className="form-group">
      <label>Image</label>
      <input 
        type="file" 
        accept="image/*" 
        onChange={e => setTestimonialImage(e.target.files[0])} 
      />
    </div>

    <div className="form-group">
      <label>Name</label>
      <input 
        type="text"
        value={testimonial.name} 
        onChange={e => setTestimonial({ ...testimonial, name: e.target.value })} 
      />
    </div>

    <div className="form-group">
      <label>Company</label>
      <input 
        type="text"
        value={testimonial.company} 
        onChange={e => setTestimonial({ ...testimonial, company: e.target.value })} 
      />
    </div>

    <div className="form-group">
      <label>Description</label>
      <textarea 
        value={testimonial.desc} 
        onChange={e => setTestimonial({ ...testimonial, desc: e.target.value })} 
      />
    </div>

    <div className="form-group">
      <label>Month</label>
      <input 
        type="text"
        value={testimonial.month} 
        onChange={e => setTestimonial({ ...testimonial, month: e.target.value })} 
      />
    </div>

    <div className="form-group">
      <label>Day</label>
      <input 
        type="text"
        value={testimonial.day} 
        onChange={e => setTestimonial({ ...testimonial, day: e.target.value })} 
      />
    </div>

    <button onClick={handleTestimonialSubmit}>
      {editTestId ? 'Update' : 'Add'} Testimonial
    </button>
  </div>
)}


        {/* Testimonials Table */}
        <div className="table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Company</th>
                <th>Description</th>
                <th>Month</th>
                <th>Day</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {testimonials.map(t => (
                <tr key={t._id}>
                  <td>
                    <img 
                      src={`${BASE_URL}${t.img}`} 
                      alt={t.name} 
                      style={{ borderRadius: '50%' }} 
                    />
                  </td>
                  <td>{t.name}</td>
                  <td>{t.company}</td>
                  <td>{t.desc}</td>
                  <td>{t.month}</td>
                  <td>{t.day}</td>
                  <td className="action-buttons">
                    <button className="edit-btn" onClick={() => handleEdit(t, 'testimonial')}>
                      Edit
                    </button>
                    <button className="delete-btn" onClick={() => handleDelete(t._id, 'testimonial')}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminTestimonial;